import '../../styles/templates/blog.scss';
import { docReady } from '../helpers/docReady';
docReady(() => {
    // console.log('Blog Template');
});
